import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { CytoscapeOptions, StylesheetJsonBlock } from 'cytoscape';
import { ToastrService } from 'ngx-toastr';
import { AcLineSegmentService } from '../../../services/ac-line-segment.service';
import cytoscape from 'cytoscape';

const TRANSMISSION_STATION_SVG = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="20" height="20" rx="10" fill="#7A28FF"/>
<path d="M6.42414 11.2695C5.47119 10.3165 4.94531 9.04593 4.94531 7.69416C4.94531 6.34239 5.47119 5.07534 6.42414 4.11886C6.56177 3.98121 6.78412 3.98121 6.92177 4.11886C7.05943 4.26005 7.05943 4.4824 6.92177 4.62003C6.10295 5.43886 5.65119 6.53299 5.65119 7.69416C5.65119 8.85886 6.10295 9.94946 6.92177 10.7718C7.05943 10.9094 7.05943 11.1318 6.92177 11.2695C6.79371 11.4043 6.55571 11.408 6.42414 11.2695Z" fill="white"/>
<path d="M7.42613 5.11886C7.56378 4.98121 7.78614 4.98121 7.92379 5.11886C8.06142 5.25652 8.06142 5.48238 7.92379 5.62003C6.78026 6.76356 6.77673 8.6271 7.92379 9.77416C8.06142 9.91181 8.06142 10.1341 7.92379 10.2718C7.78051 10.4151 7.54976 10.4019 7.42613 10.2718C6.00379 8.85299 6.00379 6.54121 7.42613 5.11886Z" fill="white"/>
<path d="M12.072 9.77416C13.219 8.6271 13.219 6.76356 12.072 5.62003C11.9343 5.48238 11.9343 5.25652 12.072 5.11886C12.2096 4.98121 12.432 4.98121 12.5696 5.11886C13.992 6.54121 13.992 8.85299 12.5696 10.2718C12.446 10.4019 12.2152 10.415 12.072 10.2718C11.9343 10.1341 11.9343 9.91181 12.072 9.77416Z" fill="white"/>
<path d="M9.99414 6.17188C10.8472 6.1719 11.5223 6.86598 11.5225 7.69629C11.5225 8.14343 11.3224 8.6066 10.9121 8.91797C10.8803 8.93914 10.8482 8.96027 10.8164 8.98145C10.8164 11.2402 11.5647 13.4358 12.9482 15.2217L12.9902 15.2773H14.1621C14.3598 15.2773 14.5156 15.4367 14.5156 15.6309C14.5156 15.8249 14.3597 15.9834 14.1621 15.9834H5.8291C5.63514 15.9833 5.47662 15.8249 5.47656 15.6309C5.47656 15.4368 5.63511 15.2775 5.8291 15.2773H7.00098L7.04395 15.2217C8.42746 13.4358 9.17479 11.2402 9.1748 8.98145C8.74241 8.69318 8.51521 8.29338 8.47656 7.83105C8.40296 6.94328 9.0921 6.17188 9.99414 6.17188Z" fill="white"/>
<path d="M13.0723 4.11914C13.2099 3.98166 13.4317 3.98162 13.5693 4.11914C14.5223 5.07561 15.0488 6.34258 15.0488 7.69434C15.0488 9.04611 14.5223 10.3166 13.5693 11.2695C13.4378 11.408 13.2002 11.4041 13.0723 11.2695C12.9346 11.1319 12.9347 10.9101 13.0723 10.7725C13.8911 9.9501 14.3428 8.85904 14.3428 7.69434C14.3428 6.53323 13.891 5.43892 13.0723 4.62012C12.9346 4.48249 12.9346 4.26033 13.0723 4.11914Z" fill="white"/>
</svg>
`
const INJECTION_SUBSTATION_SVG = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="20" height="20" rx="10" fill="#ED6B00"/>
<path d="M14.4102 11.7998C14.7433 11.717 15.0712 11.9196 15.1523 12.2441C15.2347 12.5722 15.0339 12.9038 14.707 12.9854L11.6504 13.5977C11.3303 13.6787 10.992 13.4865 10.9082 13.1523C10.8269 12.8257 11.0255 12.493 11.3535 12.4111L14.4102 11.7998Z" fill="white"/>
<path d="M8.90295 14.2162H8.29152V13.75L6.45724 14.1174V14.2163H5.84581C5.50811 14.2163 5.23438 14.49 5.23438 14.8276V15.1537C5.23438 15.3225 5.37125 15.4594 5.54009 15.4594H9.20864C9.37748 15.4594 9.51436 15.3225 9.51436 15.1537V14.8276C9.51436 14.49 9.24062 14.2162 8.90295 14.2162Z" fill="white"/>
<path d="M9.49595 8.5649C9.41494 8.24017 9.08784 8.03729 8.75465 8.12009L5.69753 8.73176C5.36939 8.81363 5.17115 9.1462 5.25269 9.473C5.33652 9.80721 5.67417 9.99881 5.9943 9.91781L9.05142 9.30612C9.37829 9.22454 9.57827 8.89294 9.49595 8.5649Z" fill="white"/>
<path d="M9.49595 10.4008C9.41494 10.0761 9.08784 9.87323 8.75465 9.95603L5.69753 10.5677C5.36939 10.6496 5.17115 10.9821 5.25269 11.3089C5.33652 11.6431 5.67417 11.8348 5.9943 11.7537L9.05142 11.1421C9.37829 11.0605 9.57827 10.7289 9.49595 10.4008Z" fill="white"/>
<path d="M9.49597 12.2368C9.41494 11.9121 9.08784 11.7092 8.75465 11.792L5.69753 12.4037C5.3694 12.4855 5.17115 12.8181 5.25269 13.1449C5.33652 13.4791 5.67417 13.6707 5.9943 13.5897L9.05142 12.978C9.37829 12.8964 9.57829 12.5649 9.49597 12.2368Z" fill="white"/>
<path d="M15.1522 8.5649C15.0712 8.24017 14.7441 8.03729 14.4109 8.12009L11.3538 8.73176C11.0256 8.81363 10.8274 9.1462 10.9089 9.473C10.9928 9.80721 11.3304 9.99881 11.6505 9.91781L14.7077 9.30612C15.0345 9.22454 15.2345 8.89294 15.1522 8.5649Z" fill="white"/>
<path d="M13.1568 5.02344C12.5535 5.02344 12.0622 5.51142 12.0062 6.13122L11.6197 5.72437C11.5063 5.60497 11.3225 5.60497 11.209 5.72437L10.2334 6.73099L9.25776 5.72437C9.14433 5.60497 8.96054 5.60497 8.84711 5.72437L8.46061 6.13122C8.40464 5.5114 7.91327 5.02344 7.31003 5.02344C6.66938 5.02344 6.14844 5.57183 6.14844 6.24618C6.14844 6.55359 6.26036 6.83144 6.43884 7.04651V7.95557L8.18124 7.58815V7.31017L9.05241 6.37274L10.0087 7.39974C10.1221 7.51915 10.3253 7.51915 10.4387 7.39974L11.4144 6.37274L12.2856 7.31022V7.95559L14.028 7.58817V7.04649C14.2064 6.83144 14.3184 6.55359 14.3184 6.24616C14.3184 5.57181 13.7974 5.02344 13.1568 5.02344Z" fill="white"/>
<path d="M13.9482 14.2158H14.5596C14.8971 14.216 15.1709 14.4906 15.1709 14.8281V15.1533C15.1709 15.322 15.0339 15.4588 14.8652 15.459H11.1963C11.0275 15.459 10.8906 15.3221 10.8906 15.1533V14.8281C10.8906 14.4905 11.1643 14.2159 11.502 14.2158H12.1133V14.1172L13.9482 13.75V14.2158ZM14.4111 9.95605C14.7441 9.87345 15.0712 10.076 15.1523 10.4004C15.2346 10.7283 15.0346 11.0598 14.708 11.1416L11.6504 11.7539C11.3303 11.8348 10.993 11.6427 10.9092 11.3086C10.8278 10.9819 11.0256 10.6493 11.3535 10.5674L14.4111 9.95605Z" fill="white"/>
</svg>
`;

const DISTRIBUTION_SUBSTATION_SVG = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="24" height="24" rx="12" fill="#005EFF"/>
<path d="M6.81152 9.57031V16.3125H5.97656C5.85213 16.3124 5.73256 16.2628 5.64453 16.1748C5.55662 16.0867 5.50788 15.9671 5.50781 15.8428V10.04C5.50787 9.91558 5.55667 9.79607 5.64453 9.70801C5.73256 9.62013 5.85213 9.57042 5.97656 9.57031H6.81152ZM17.999 9.57031C18.1235 9.57031 18.2429 9.62013 18.3311 9.70801C18.419 9.79607 18.4687 9.91555 18.4688 10.04V15.8428C18.4687 15.9671 18.419 16.0867 18.3311 16.1748C18.243 16.2628 18.1235 16.3125 17.999 16.3125H17.165V9.57031H17.999Z" fill="white"/>
<path d="M10.8848 18.7471C10.8784 18.8619 10.8299 18.971 10.748 19.0527C10.6601 19.1407 10.5405 19.1904 10.416 19.1904H10.1309C10.0064 19.1904 9.88677 19.1407 9.79883 19.0527C9.71702 18.971 9.66849 18.8618 9.66211 18.7471H10.8848ZM14.6562 18.7471C14.6498 18.8619 14.6014 18.971 14.5195 19.0527C14.4316 19.1407 14.3119 19.1904 14.1875 19.1904H13.9023C13.778 19.1904 13.6582 19.1406 13.5703 19.0527C13.4886 18.971 13.44 18.8618 13.4336 18.7471H14.6562ZM15.2832 17.7432C15.2831 17.752 15.2821 17.8383 15.2812 17.8477C15.26 18.0871 15.0585 18.2753 14.8135 18.2754H9.15625C8.90802 18.2752 8.70525 18.0819 8.68848 17.8379C8.68788 17.8278 8.68753 17.7541 8.6875 17.748L8.69922 17.7344H15.2744L15.2832 17.7432Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8534 12.7712L11.4053 13.3924C11.361 13.4537 11.3549 13.5347 11.3893 13.602C11.4237 13.6694 11.4931 13.7117 11.5687 13.7117H11.7407L11.4056 14.1744C11.3403 14.2644 11.3603 14.3905 11.4505 14.4558C11.5405 14.5211 11.6667 14.5009 11.7319 14.4109L12.2987 13.6284C12.3432 13.5671 12.3494 13.486 12.315 13.4187C12.2805 13.3512 12.2112 13.3087 12.1356 13.3087H11.9625L12.1802 13.0069C12.2453 12.9167 12.2248 12.7906 12.1347 12.7256C12.0445 12.6605 11.9183 12.6808 11.8534 12.7712Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.8814 7.67891H10.8882V5.26644C10.8882 5.14185 10.8388 5.02243 10.7506 4.93445C10.6627 4.84633 10.5432 4.79688 10.4186 4.79688C10.325 4.79688 10.2269 4.79688 10.1333 4.79688C10.0087 4.79688 9.88928 4.84633 9.8013 4.93445C9.71318 5.02243 9.66372 5.14185 9.66372 5.26644V7.67891H6.67229C6.54268 7.67891 6.4375 7.78409 6.4375 7.9137C6.4375 8.04314 6.54268 8.14849 6.67229 8.14849H17.3014C17.431 8.14849 17.5361 8.04316 17.5361 7.9137C17.5361 7.78409 17.431 7.67891 17.3014 7.67891H14.1058V5.26644C14.1058 5.14185 14.0564 5.02243 13.9684 4.93445C13.8803 4.84633 13.7608 4.79688 13.6363 4.79688C13.5428 4.79688 13.4445 4.79688 13.3509 4.79688C13.2265 4.79688 13.1071 4.84633 13.0189 4.93445C12.9308 5.02243 12.8814 5.14185 12.8814 5.26644V7.67891Z" fill="white"/>
<path d="M8.88281 6.67445C8.88281 6.54359 8.9889 6.4375 9.11976 6.4375H9.66874V6.9114H9.11976C8.9889 6.9114 8.88281 6.80531 8.88281 6.67445Z" fill="white"/>
<path d="M8.88281 5.67445C8.88281 5.54359 8.9889 5.4375 9.11976 5.4375H9.66874V5.9114H9.11976C8.9889 5.9114 8.88281 5.80531 8.88281 5.67445Z" fill="white"/>
<path d="M12.1016 5.67445C12.1016 5.54359 12.2076 5.4375 12.3385 5.4375H12.8875V5.9114H12.3385C12.2076 5.9114 12.1016 5.80531 12.1016 5.67445Z" fill="white"/>
<path d="M14.9062 5.67445C14.9062 5.54359 14.8002 5.4375 14.6693 5.4375H14.1203V5.9114H14.6693C14.8002 5.9114 14.9062 5.80531 14.9062 5.67445Z" fill="white"/>
<path d="M11.6797 5.67445C11.6797 5.54359 11.5736 5.4375 11.4427 5.4375H10.8938V5.9114H11.4427C11.5736 5.9114 11.6797 5.80531 11.6797 5.67445Z" fill="white"/>
<path d="M12.1016 6.67445C12.1016 6.54359 12.2076 6.4375 12.3385 6.4375H12.8875V6.9114H12.3385C12.2076 6.9114 12.1016 6.80531 12.1016 6.67445Z" fill="white"/>
<path d="M14.9062 6.67445C14.9062 6.54359 14.8002 6.4375 14.6693 6.4375H14.1203V6.9114H14.6693C14.8002 6.9114 14.9062 6.80531 14.9062 6.67445Z" fill="white"/>
<path d="M11.6797 6.67445C11.6797 6.54359 11.5736 6.4375 11.4427 6.4375H10.8938V6.9114H11.4427C11.5736 6.9114 11.6797 6.80531 11.6797 6.67445Z" fill="white"/>
<path d="M9.19727 8.625V12.9521C9.19727 13.0816 9.30301 13.1875 9.43262 13.1875C9.5621 13.1873 9.66699 13.0815 9.66699 12.9521V8.625H11.7539V9.74902C11.7539 9.87861 11.8587 9.98433 11.9883 9.98438C12.1179 9.98438 12.2236 9.87863 12.2236 9.74902V8.625H14.3096V12.9521C14.3096 13.0815 14.4145 13.1873 14.5439 13.1875C14.6736 13.1875 14.7793 13.0816 14.7793 12.9521V8.625H16.2256C16.4849 8.625 16.6953 8.83538 16.6953 9.09473V16.8105C16.6952 17.0698 16.4848 17.2803 16.2256 17.2803H14.7793V16.1553C14.7793 16.0257 14.6736 15.9199 14.5439 15.9199C14.4145 15.9202 14.3096 16.0258 14.3096 16.1553V17.2803H12.2236V16.1553C12.2236 16.0257 12.1179 15.9199 11.9883 15.9199C11.8587 15.92 11.7539 16.0257 11.7539 16.1553V17.2803H9.66699V16.1553C9.66699 16.0258 9.5621 15.9201 9.43262 15.9199C9.30301 15.9199 9.19727 16.0257 9.19727 16.1553V17.2803H7.75098C7.49172 17.2803 7.2814 17.0698 7.28125 16.8105V9.09473C7.28125 8.83538 7.49163 8.625 7.75098 8.625H9.19727ZM11.9883 11.209C11.8206 11.209 11.6659 11.2982 11.582 11.4434C11.1045 12.2704 10.3164 13.6339 9.83887 14.4609C9.75508 14.6063 9.75516 14.7855 9.83887 14.9307C9.9228 15.076 10.0784 15.165 10.2461 15.165H13.7305C13.8982 15.165 14.0538 15.076 14.1377 14.9307C14.2214 14.7854 14.2215 14.6063 14.1377 14.4609C13.6602 13.634 12.8731 12.2705 12.3955 11.4434C12.3116 11.2981 12.1561 11.209 11.9883 11.209Z" fill="white"/>
</svg>
`

const transmissionStationSvgBase64 =
`data:image/svg+xml;base64,${btoa(
String.fromCharCode(...new TextEncoder().encode(TRANSMISSION_STATION_SVG))
)}`;

const injectionSubstationSvgBase64 =
`data:image/svg+xml;base64,${btoa(
String.fromCharCode(...new TextEncoder().encode(INJECTION_SUBSTATION_SVG))
)}`;

const distributionSubstationSvgBase64 =
`data:image/svg+xml;base64,${btoa(
String.fromCharCode(...new TextEncoder().encode(DISTRIBUTION_SUBSTATION_SVG))
)}`;

const CY_STYLE: StylesheetJsonBlock[] = [
  {
    selector: 'node.TS',
    style: {
      'width': 15,
      'height': 15,
      'background-color': '#7a28ff',
      'background-image': transmissionStationSvgBase64,
      'background-opacity': 1,
    },
  },
  {
    selector: 'node.INJ-SS',
    style: {
      'width': 15,
      'height': 15,
      'background-color': '#ed6b00',
      'background-image': injectionSubstationSvgBase64,
      'background-opacity': 1,
    },
  },
  {
    selector: 'node.DS',
    style: {
      'width': 12,
      'height': 12,
      'background-color': '#005eff',
      'background-image': distributionSubstationSvgBase64,
      'background-opacity': 1,
    },
  },
   {
    selector: 'node.transparent',
    style: {
      'width': 12,
      'height': 12,
      'background-opacity': 0,
      'border-width': 0,
    },
  },
  {
    selector: 'node',
    style: {
      'shape': 'ellipse',
      'background-fit': 'contain',
      'border-width': 0
    }
  },
  {
    selector: 'edge.HV-MV',
    style: {
      'line-color': '#e600ff',
      'taxi-turn': 10000
    }
  },
  {
    selector: 'edge.MV-LV',
    style: {
      'line-color': '#94d02c',
      'taxi-turn': 10000
    }
  },
  {
    selector: 'edge',
    style: {
      'width': 1.5,
      'curve-style': 'taxi',
      'taxi-direction': 'downward'
    }
  }
];

interface ApiSchematicNode {
  id: string;
  label: string;
  voltageClass: 'HV' | 'MV' | 'LV' | 'null';
}

interface ApiSchematicEdge {
  id: string;
  source: string;
  target: string;
  label: string;
  kv: number;
  voltageClass: 'HV' | 'MV' | 'LV';
  totalCount: number;
  taggedCount: number;
  untaggedCount: number;
}

interface ApiSchematic {
  nodes: ApiSchematicNode[];
  edges: ApiSchematicEdge[];
}

@Component({
  selector: 'lib-ac-line-schematic',
  standalone: false,
  templateUrl: './ac-line-schematic.component.html',
  styleUrl: './ac-line-schematic.component.scss'
})
export class AcLineSchematicComponent implements AfterViewInit, OnChanges, OnDestroy {

  @ViewChild('cyAcLineContainer', { static: true })
  cyMapContainer!: ElementRef<HTMLDivElement>; 
  cy: cytoscape.Core | null = null;
  dataFromApi!: ApiSchematic;
  private resizeObserver!: ResizeObserver;
  @Input() acLineId: number | null = null;

  constructor(private toastr: ToastrService, private acLineService: AcLineSegmentService){}

  ngAfterViewInit(): void {
    this.getAcLineSchematic();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['acLineId'] && 
        !changes['acLineId'].firstChange) {

      if (this.acLineId != null) {
        this.getAcLineSchematic();
      }
    }
  }

  getAcLineSchematic(){
    if (!this.acLineId) {
      this.toastr.warning('Schematic is not available for this ac line.');
      return;
    }
    this.acLineService.getAcLineSchematic(this.acLineId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.dataFromApi = responseData.data;
          this.buildSchematicElements(this.dataFromApi);
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: () => {
        this.toastr.error('Error fetching data for Ac Line Schematic Diagram.');
      },
    });
  }

  buildSchematicElements(data: ApiSchematic) {
    const Y_STEP = 40;
    const ZIGZAG_Y_STEP = 30;
    const X_OFFSET = 40;

    const nodePositions = new Map<string, { x: number; y: number }>();
    const childrenMap = new Map<string, Set<string>>();

    // build children map
    data.edges.forEach(e => {
      if (!childrenMap.has(e.source)) {
        childrenMap.set(e.source, new Set());
      }
      childrenMap.get(e.source)!.add(e.target);
    });

    // default vertical layout
    let currentY = 0;
    data.nodes.forEach(node => {
      currentY += Y_STEP;
      nodePositions.set(node.id, { x: 0, y: currentY });
    });

    // source substation → children zig-zag
    data.nodes.forEach(node => {
      const isSource = node.id?.startsWith('source');
      const children = Array.from(childrenMap.get(node.id) ?? []);

      if (!isSource || children.length <= 1) return;

      const parentPos = nodePositions.get(node.id)!;

      children.forEach((childId, index) => {
        const x =
          index % 2 === 0
            ? parentPos.x - X_OFFSET
            : parentPos.x + X_OFFSET;

        const y =
          index === 0
            ? parentPos.y + Y_STEP
            : parentPos.y + Y_STEP + index * ZIGZAG_Y_STEP;

        nodePositions.set(childId, { x, y });
      });
    });

    // handle edges with missing target
    data.edges.forEach(edge => {
      if (!edge.target || edge.target === 'null') {

        const fakeId = `virtual-${edge.id}`;

        // add fake node to API node list
        data.nodes.push({
          id: fakeId,
          label: '',
          voltageClass: 'null'
        });

        // give it position under the source node
        const sourcePos = nodePositions.get(edge.source);

        if (sourcePos) {
          nodePositions.set(fakeId, {
            x: sourcePos.x,
            y: sourcePos.y + 80
          });
        }

        // redirect edge target to fake node
        edge.target = fakeId;
      }
    });

    // map to cytoscape
    const cyNodes = data.nodes.map(node => {
      const pos = nodePositions.get(node.id)!;

      let classes = '';

      if (node.voltageClass === 'HV') classes = 'TS';
      else if (node.voltageClass === 'MV') classes = 'INJ-SS';
      else if (node.voltageClass === 'LV') classes = 'DS';
      else classes = 'transparent'
    
      return {
        data: {
          id: node.id,
          label: node.label,
        },
        position: pos,
        classes
      };
    });

    const cyEdges = this.mapEdges(data.edges);
    this.renderSchematic(cyNodes, cyEdges);
  }

  private mapEdges(apiEdges: ApiSchematicEdge[]) {
    return apiEdges.map(edge => {
      let classes = '';

      classes = edge.voltageClass === 'HV' ? 'HV-MV' : 'MV-LV';
      
      return {
        data: {
          id: edge.id,
          source: edge.source,
          target: edge.target,
          label: edge.label,
          kv: edge.kv,
          totalCount: edge.totalCount,
          taggedCount: edge.taggedCount,
          untaggedCount: edge.untaggedCount
        },
        classes
      };
    });
  }

  private renderSchematic(nodes: any[], edges: any[]) {
    const cyJson: CytoscapeOptions = {
      container: this.cyMapContainer.nativeElement,
      elements: {
        nodes,
        edges
      },
      layout: {
        name: 'preset'
      },
      style: CY_STYLE,
      wheelSensitivity: 0.4
    };

    try
    {
      this.cy = cytoscape(cyJson);
    }
    catch
    {
      this.toastr.error("Something went wrong with generating diagram.")
      return;
    }

    // just in case of rare fail cases
    if (!this.cy){
      this.toastr.error("Something went wrong with generating diagram.")
      return;
    }

    this.resizeObserver = new ResizeObserver(() => {
      if (!this.cy) return;

      this.cy.resize();
      this.cy.fit(undefined, 40);
    });

    this.resizeObserver.observe(this.cyMapContainer.nativeElement);
    this.createTooltips();
  }

    private createTooltips(){
    const tooltip = document.createElement('div');
    tooltip.style.position = 'absolute';
    tooltip.style.pointerEvents = 'none';
    tooltip.style.color = "#ffffff"
    tooltip.style.background = '#1a1a1a';
    tooltip.style.border = '1px solid #303030';
    tooltip.style.padding = '4px 8px';
    tooltip.style.borderRadius = '4px';
    tooltip.style.fontSize = '12px';
    tooltip.style.display = 'none';
    tooltip.style.zIndex = '9999';
    tooltip.style.display = 'block';
    tooltip.style.visibility = 'hidden';

    this.cy!.container()!.appendChild(tooltip);

    let tooltipActive = false;

    this.cy!.on('mouseover', 'node', (e) => {
      if (e.target.hasClass('transparent')) return;
      tooltip.textContent = e.target.data('label');
      tooltipActive = true;
    });

    this.cy!.on('mouseover', 'edge', (e) => {
      const ssType = (e.target.hasClass('HV-MV')) ? 'INJ SS' : 'DS';
      tooltip.innerHTML = `
        ${e.target.data('label')}<br/>
        ${e.target.data('kv')}kv - ${e.target.data('totalCount')} ${ssType}<br/>
        ${e.target.data('taggedCount')} tagged, ${e.target.data('untaggedCount')} untagged
      `;
      tooltipActive = true;
    });

    this.cy!.on('mousemove', (e) => {
      if (!tooltipActive) return;

      const zoom = parseFloat(getComputedStyle(document.documentElement).zoom || '1');

      const offsetX = e.originalEvent.offsetX / zoom;
      const offsetY = e.originalEvent.offsetY / zoom;

      tooltip.style.left = `${offsetX + 15}px`;
      tooltip.style.top = `${offsetY - 2}px`;

      tooltip.style.visibility = 'visible';
    });

    this.cy!.on('mouseout', () => {
      tooltipActive = false;
      tooltip.style.visibility = 'hidden';
    });

    this.cy!.on('grab', () => {
      tooltipActive = false;
      tooltip.style.visibility = 'hidden';
    });

    this.cy!.on('tap', () => {
      tooltipActive = false;
      tooltip.style.visibility = 'hidden';
    });
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.cy?.destroy();
    this.cy = null;
  }
}
